/*
 * @Author: lidan
 * @Date: 2020-10-27 13:55:53
 * @LastEditTime: 2020-10-30 15:39:47
 * @LastEditors: lidan
 * @Description: 规则设置-服务评价设置
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\serviceComment.js
 */
import http from 'e6-base-core/axios/config'
/************************ 服务评价设置 ******************************* */
import { e6ModuleOrderWaybillProcessApi } from '@/config/api'

const {
  host = '',
  E6_MS_TMS_BASE_WEB,
  E6_MS_TMS_EVALUATE_WEB = '',
  E6_MS_TMS_E6YUN_BASE_WEB = '',
} = e6ModuleOrderWaybillProcessApi
// 获取服务评价设置
export function getEvaluateSetting() {
  return http({
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/getEvaluateSetting`,
    method: 'get',
  })
}

// 保存服务评价设置
export function saveEvaluateSetting(data) {
  return http({
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/saveEvaluateSetting`,
    method: 'post',
    data,
  })
}

// 查询服务评价明细表头
export function getEvaluateColumn() {
  return http({
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/getEvaluateColumn`,
    method: 'get',
  })
}

// 获取服务评价明细列表
export function listEvaluationReport(data) {
  return http({
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/listEvaluationReport`,
    method: 'post',
    data,
  })
}

// 导出服务评价明细
export function exportEvaluationReport(data) {
  return http({
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/exportEvaluationReport`,
    method: 'post',
    data,
  })
}

// 下拉框查询区域名称位置
export function getAreaLablePositionEvaluate(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: 'post',
    data,
  })
}
// 下拉框查询评价人员
export function ShipperReceiverDropBox(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/ShipperReceiverDropBox?type=`,
    method: 'get',
    params,
  })
}
// 查询年度评价汇总表头
export function getAnnualSummaryColumn() {
  return http({
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/getAnnualSummaryColumn`,
    method: 'get',
  })
}

// 获取年度评价汇总列表
export function listAnnualSummary(data) {
  return http({
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/listAnnualSummary`,
    method: 'post',
    data,
  })
}

// 导出年度评价汇总列表
export function exportAnnualSummary(data) {
  return http({
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    url: `${host}${E6_MS_TMS_EVALUATE_WEB}/evaluate/exportAnnualSummary`,
    method: 'post',
    data,
  })
}
